module.exports = __webpack_public_path__ + "img/onboard.7dd362dc.svg";